<div class="apenas--mobile">
  <div class="container-principal__header">
    <dynamic-form [fields]="regLabelMenuCacauLover"></dynamic-form>
  </div>
</div>
<div class="apenas--desktop">
  <div class="container-principal__header header--desktop">
    <img
      class="header__voltar"
      src="assets/images/icons/voltar.png"
      (click)="voltarPaginaAnterior()"
    />
    <label class="cs_label header__titulo">Descontos para Lovers</label>
  </div>
</div>
<div class="container-principal__conteudo">
  <div class="descontos">
    <ngx-skeleton-loader
      count="3"
      [theme]="{
        'border-radius': '10px',
        height: '300px',
        width: '90%',
        display: 'block',
        margin: 'auto',
        'margin-bottom': '2rem'
      }"
      *ngIf="carregandoDescontos"
    ></ngx-skeleton-loader>
    <dynamic-form
      [fields]="regProdutosDesconto"
      *ngIf="!carregandoDescontos"
    ></dynamic-form>
  </div>
</div>
